export default __webpack_public_path__ + "static/media/sheet_thumb05_budgetplanner1@2x.2aabe2cb.png";